module.exports = __webpack_public_path__ + "img/logo-whypay.e5f3b299.png";